export default __webpack_public_path__ + "media/Objective/Objective-Black-920a4cf39b9db25765280aa996016bb3.woff2";